/**
 * @typedef {Object} Banner
 * @property {number} id — identificador estable (analitica); nombre puede ir vacio
 * @property {string} imageUrl
 * @property {string} title
 * @property {string} link
 * @property {string} tipo  — 'catalogo' | 'banner'
 */

export const isCatalog = (banner) => banner !== null && banner.tipo === 'catalogo';

export const isRegularBanner = (banner) => banner !== null && banner.tipo !== 'catalogo';